import { useState } from "react";

export const useUploadZone = (
  dropHandler: (e: React.DragEvent<HTMLDivElement>) => void
) => {
  const [drag, setDrag] = useState<boolean>(false);

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDrag(false);
    dropHandler(e);
  };

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDrag(true);
  };

  const handleLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDrag(false);
  };

  return {
    drag,
    handleDrop,
    handleDrag,
    handleLeave,
  };
};
